import { TBadgeCount } from '@/shared/Badges/BadgeCount'
import { TReportMaintenanceEvent } from './components/OrganizationUsersReportView'
import { IMaintenanceEvent, TUnplannedMaintenanceEvent } from '@/pages/Calendar/calendar.types'

const getBadgeType = (eventCount: Record<TReportMaintenanceEvent, number>): TBadgeCount => {
  if (!eventCount || (eventCount.PLANNED_MAINTENANCE > 0 && eventCount.OVERDUE_MAINTENANCE > 0)) return null
  if (eventCount.PLANNED_MAINTENANCE > 0) return 'blue'
  if (eventCount.OVERDUE_MAINTENANCE > 0) return 'error'
  return 'default'
}

const getTooltipText = (eventCount: Record<TReportMaintenanceEvent, number>): string => {
  if (!eventCount || (eventCount.PLANNED_MAINTENANCE > 0 && eventCount.OVERDUE_MAINTENANCE > 0)) return null
  if (eventCount.PLANNED_MAINTENANCE > 0) return `Запланировано: ${eventCount.PLANNED_MAINTENANCE}`
  if (eventCount.OVERDUE_MAINTENANCE > 0) return `Просрочено: ${eventCount.OVERDUE_MAINTENANCE}`
  if (!eventCount.COMPLETED_MAINTENANCE && eventCount.UNPLANNED > 0) return `Внеплановых: ${eventCount.UNPLANNED}`
  return (
    `Завершено: ${eventCount.COMPLETED_MAINTENANCE}` +
    (eventCount.UNPLANNED > 0 ? `\n(Внеплановых: ${eventCount.UNPLANNED})` : '')
  )
}

const getTooltipPosition = (
  colIndex: number,
  rowIndex: number,
  colsNum: number,
  rowsNum: number,
  leadColExist: boolean
) => {
  const horTooltipPos = colIndex > colsNum / 2 ? 'left' : 'right'
  if (rowsNum - rowIndex < 3 || colsNum - colIndex < 4 || (leadColExist && colIndex < 4)) return horTooltipPos

  return 'bottom'
}

const parseUnplannedEvents = (
  e: TUnplannedMaintenanceEvent
): Omit<IMaintenanceEvent, 'type'> & { type: 'UNPLANNED' } => ({
  id: e.id,
  type: e.type,
  ts: new Date(e.createdAt).getTime(),
  metadata: {
    responsibleUsers: [e.createdBy.id],
    equipmentId: e.equipmentId,
    processId: null,
    processRuleId: null,
  },
})

const reportTableUtils = { getBadgeType, getTooltipText, parseUnplannedEvents, getTooltipPosition }
export default reportTableUtils
